import { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-flexbox-grid";
import { useGlobalContext } from "context/GlobalContext";
import { fetchBackend } from "helpers";
import { useHistory } from "react-router-dom";
import { COMPLAINT, REPORT } from "constants/index";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import MessageIcon from "@material-ui/icons/Message";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import styled from "styled-components";

import dataNotFound from "assets/images/auth/icons/data-not-found.png";

const StyledAccordion = styled(Accordion)`
  .MuiListItem-container {
    width: 100%;
  }

  //   .MuiPaper-root {
  //     box-shadow: none !important;
  //   }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  background: #f0f0f0;
  width: 100%;
  padding: 0px !important;

  & .row {
    width: 100%;
  }

  .single--item {
    padding: 8px 16px !important;
  }

  .footer {
    padding: 4px 0px;
    margin: 0 !important;
    background: red;
    color: #fff;
  }
`;

export const ReportList = () => {
  const [currentData, setData] = useState([]);

  const gContext = useGlobalContext();
  const history = useHistory();

  const getComplaints = useCallback(
    async (type, id) => {
      const { error, response } = await fetchBackend({
        url: `complaint/type/${type}/${id}`,
      });

      if (!error) {
        setData(response);
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar obtener los reportes, revisa tu conexión a internet",
          type: "error",
        });
      }
    },
    [gContext]
  );

  const getInitialState = useCallback(async () => {
    const userId = gContext.currentUser?._id || "";
    const type = history.location.pathname.match("vehiculos")
      ? REPORT
      : COMPLAINT;

    if (userId) {
      await Promise.all([getComplaints(type, userId)]);
    }
  }, [gContext.currentUser, history.location]);

  useEffect(() => {
    getInitialState();
  }, [getInitialState]);

  console.log(history.location.pathname);

  if (!currentData.length) {
    return (
      <Row center="xs" moiddle="xs" className="h-100">
        <Col md={12}>
          <h3>Aún no has levantado ningun reporte</h3>
          <img src={dataNotFound} alt="data-not-found" className="m-auto" />
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col md={12}>
        <List>
          {currentData.map(
            ({ _id, brandCar, modelCar, time, platesCar, place }) => (
              <SingleReport
                key={_id}
                _id={_id}
                brandCar={brandCar}
                modelCar={modelCar}
                time={time}
                platesCar={platesCar}
                place={place}
              />
            )
          )}
        </List>
      </Col>
    </Row>
  );
};

const SingleReport = ({
  _id = "",
  brandCar = "",
  modelCar = "",
  time,
  platesCar,
  place,
}) => {
  const gContext = useGlobalContext();
  const singleTime = new Date(time);
  const currentTime = `${singleTime.getHours()}:${singleTime.getMinutes()}`;
  return (
    <StyledAccordion>
      <AccordionSummary aria-controls="panel2a-content">
        <>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Typography component="span" variant="body2" color="textPrimary">
                {currentTime}
              </Typography>
            </ListItemAvatar>
            <ListItemText
              primary={`${brandCar} ${modelCar}`}
              secondary={
                <>
                  <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                  >
                    {`Placas: ${platesCar}`}
                  </Typography>
                </>
              }
            />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="expand">
                <FiberManualRecordIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider variant="inset" component="li" />
        </>
      </AccordionSummary>
      <StyledAccordionDetails>
        <Row className="m0">
          <Col md={12} className="p0">
            <Row className="single--item">
              <Col md={12}>
                <Typography variant="caption" color="textSecondary">
                  Tipo de reporte
                </Typography>
              </Col>
              <Col md={12}>
                <Typography variant="body2">Reporte de vehículo</Typography>
              </Col>
            </Row>
            <Row className="single--item">
              <Col md={12}>
                <Typography variant="caption" color="textSecondary">
                  Lugar de robo
                </Typography>
              </Col>
              <Col md={12}>
                <Typography variant="body2">
                  {`${place?.street}, ${place?.neighborhood}, ${place?.city}, ${place?.state}, Referencia: ${place?.reference}`}
                </Typography>
              </Col>
            </Row>
            <Row className="single--item">
              <Col md={12}>
                <Typography variant="caption" color="textSecondary">
                  Hora de reporte
                </Typography>
              </Col>
              <Col md={12}>
                <Typography variant="body2">{currentTime}</Typography>
              </Col>
            </Row>
            <Row className="footer status ">
              <Col md={6}>
                <Typography variant="body2">Robado</Typography>
              </Col>
              <Col md={6}>
                <Row end="xs" middle="xs">
                  <MessageIcon
                    onClick={() => gContext.toggleChatModal(_id)}
                    className="pointer"
                  />
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
